"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.baseOffsets = exports.getMainDir = exports.setOrReset = exports.curryTernary = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _get = _interopRequireDefault(require("lodash/get"));

var _debounce = _interopRequireDefault(require("lodash/debounce"));

var _throttle = _interopRequireDefault(require("lodash/throttle"));

var config = _interopRequireWildcard(require("@8x8/oxygen-config"));

var _oxygenConstants = require("@8x8/oxygen-constants");

var _constants = require("../../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var throttleWait = 50;
var debounceWait = 100;
var errorOffset = 1;

var curryTernary = function curryTernary(predicate) {
  return function (right) {
    return function (left) {
      return predicate ? right : left;
    };
  };
};

exports.curryTernary = curryTernary;

var setOrReset = function setOrReset(predicate) {
  return function (right) {
    return curryTernary(predicate)(right)([0, 0]);
  };
};

exports.setOrReset = setOrReset;

var getMainDir = function getMainDir(flyoutSize, idealDirection, triggerRect, windowSize) {
  var margin = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var predicateVertical = windowSize.width - triggerRect.right > 0;
  var predicateHorizontal = windowSize.height - triggerRect.bottom > 0;

  var _setOrReset = setOrReset(predicateVertical)([triggerRect.top - flyoutSize.height + margin, windowSize.height - flyoutSize.height - triggerRect.bottom - margin]),
      _setOrReset2 = _slicedToArray(_setOrReset, 2),
      up = _setOrReset2[0],
      down = _setOrReset2[1];

  var _setOrReset3 = setOrReset(predicateHorizontal)([triggerRect.left - flyoutSize.width - margin, windowSize.width - flyoutSize.width - triggerRect.right - errorOffset - margin]),
      _setOrReset4 = _slicedToArray(_setOrReset3, 2),
      left = _setOrReset4[0],
      right = _setOrReset4[1];

  var upLeft = (up + left) / 2,
      downLeft = (down + left) / 2;
  var upRight = (up + right) / 2,
      downRight = (down + right) / 2;
  var spaces = [up, right, down, left, upLeft, downLeft, upRight, downRight];
  var max = Math.max.apply(Math, spaces);
  return idealDirection && spaces[parseInt(_constants.directionsIndexMap[idealDirection], 10)] > 0 ? idealDirection : _constants.spacesIndexMap[spaces.indexOf(max)];
};

exports.getMainDir = getMainDir;

var baseOffsets = function baseOffsets(relativeOffset, flyoutSize, mainDir, triggerRect, windowSize) {
  var _offsets;

  var margin = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
  var top = windowSize.scrollY + triggerRect.top;
  var left = windowSize.scrollX + triggerRect.left;
  var offsets = (_offsets = {}, _defineProperty(_offsets, _constants.directions.bottom, {
    top: windowSize.scrollY + triggerRect.bottom + margin,
    left: left
  }), _defineProperty(_offsets, _constants.directions.top, {
    top: windowSize.scrollY + triggerRect.top - flyoutSize.height - margin,
    left: left
  }), _defineProperty(_offsets, _constants.directions.left, {
    top: top,
    left: windowSize.scrollX + triggerRect.left - flyoutSize.width - margin
  }), _defineProperty(_offsets, _constants.directions.right, {
    top: top,
    left: windowSize.scrollX + triggerRect.right + margin
  }), _defineProperty(_offsets, _constants.directions.topLeft, {
    top: windowSize.scrollY + triggerRect.top - flyoutSize.height - margin,
    left: windowSize.scrollX + triggerRect.left
  }), _defineProperty(_offsets, _constants.directions.topRight, {
    top: windowSize.scrollY + triggerRect.top - flyoutSize.height - margin,
    left: windowSize.scrollX + triggerRect.right - flyoutSize.width
  }), _defineProperty(_offsets, _constants.directions.bottomLeft, {
    top: windowSize.scrollY + triggerRect.bottom + margin,
    left: windowSize.scrollX + triggerRect.left
  }), _defineProperty(_offsets, _constants.directions.bottomRight, {
    top: windowSize.scrollY + triggerRect.bottom + margin,
    left: windowSize.scrollX + triggerRect.right - flyoutSize.width
  }), _offsets);

  var _ref = offsets[mainDir] !== undefined ? offsets[mainDir] : {
    top: top,
    left: left
  };

  top = _ref.top;
  left = _ref.left;
  return {
    top: top,
    left: left
  };
};

exports.baseOffsets = baseOffsets;

var Contents =
/*#__PURE__*/
function (_Component) {
  _inherits(Contents, _Component);

  function Contents() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Contents);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Contents)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.setFlyoutPosition(_this.props);

      setTimeout(function () {
        if (_this.props.shouldFocus && _this.flyoutRef.current) {
          _this.flyoutRef.current.focus();
        }
      });
      window.addEventListener('resize', _this.handleResize);
      window.addEventListener('keydown', _this.handleKeyDown);
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      if (_this.props.idealDirection !== prevProps.idealDirection || _this.props.margin !== prevProps.margin || _this.props.relativeOffset !== prevProps.relativeOffset || _this.props.triggerRect !== prevProps.triggerRect) {
        _this.setFlyoutPosition(prevProps);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      window.removeEventListener('resize', _this.handleResize);
      window.removeEventListener('keydown', _this.handleKeyDown);
    });

    _defineProperty(_assertThisInitialized(_this), "setFlyoutPosition", function (_ref2) {
      var idealDirection = _ref2.idealDirection,
          margin = _ref2.margin,
          relativeOffset = _ref2.relativeOffset,
          triggerRect = _ref2.triggerRect;
      var windowSize = {
        height: window.innerHeight,
        width: window.innerWidth,
        scrollX: 0,
        scrollY: 0
      };
      var flyoutSize = {
        height: (0, _get.default)(_this.flyoutRef.current, 'clientHeight', 0),
        width: (0, _get.default)(_this.flyoutRef.current, 'clientWidth', 0)
      };
      var mainDir = getMainDir(flyoutSize, idealDirection, triggerRect, windowSize, margin);
      var base = baseOffsets(relativeOffset, flyoutSize, mainDir, triggerRect, windowSize, margin);
      _this.flyoutRef.current.style.top = "".concat(base.top, "px"); // eslint-disable-line no-param-reassign

      _this.flyoutRef.current.style.left = "".concat(base.left, "px"); // eslint-disable-line no-param-reassign
    });

    _defineProperty(_assertThisInitialized(_this), "flyoutRef", _react.default.createRef());

    _defineProperty(_assertThisInitialized(_this), "handleResize", (0, _throttle.default)(_this.props.onResize, throttleWait));

    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", (0, _debounce.default)(_this.props.onKeyDown, debounceWait));

    return _this;
  }

  _createClass(Contents, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", _extends({
        ref: this.flyoutRef,
        style: {
          position: 'absolute'
        }
      }, config.getTestAttributes(this.props.testId)), this.props.children);
    }
  }]);

  return Contents;
}(_react.Component);

exports.default = Contents;

_defineProperty(Contents, "propTypes", {
  idealDirection: _propTypes.default.oneOf(_constants.directionsType),
  testId: _propTypes.default.string,
  relativeOffset: _propTypes.default.exact({
    x: _propTypes.default.number,
    y: _propTypes.default.number
  }),
  triggerRect: _propTypes.default.exact({
    bottom: _propTypes.default.number,
    height: _propTypes.default.number,
    left: _propTypes.default.number,
    right: _propTypes.default.number,
    top: _propTypes.default.number,
    width: _propTypes.default.number
  }),
  margin: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  shouldFocus: _propTypes.default.bool,
  onKeyDown: _propTypes.default.func.isRequired,
  onResize: _propTypes.default.func.isRequired,
  children: _propTypes.default.node
});

_defineProperty(Contents, "defaultProps", {
  idealDirection: _constants.directions.bottom,
  testId: 'FLYOUT',
  relativeOffset: {
    x: 0,
    y: 0
  },
  triggerRect: {
    bottom: 0,
    height: 0,
    left: 0,
    right: 0,
    top: 0,
    width: 0
  },
  margin: parseInt(_oxygenConstants.staticTooltip.margin, 10),
  shouldFocus: false,
  children: null
});